<template>
    <section class="padding-vertical-content mb-3 mb-lg-4" id="paso-1">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex align-items-center">
                        <h2 class="text-uppercase">{{ $t('bases.datos_deportista') }}</h2>
                        <div v-if="manager.documentacion_obligatoria_bases && !esRenovacion" class="ml-3">
                            <b-btn @click="show_modal = true">{{ $t('bases.informacion_importante') }}</b-btn>
                            <b-modal
                                size="xl"
                                centered
                                :hide-footer="true"
                                v-model="show_modal"
                                title="Información importante"
                            >
                                <b-row>
                                    <b-col cols="12" class="text-justify">
                                        <p>{{ $t('bases.texto_documentacion_1') }}</p>
                                        <p>{{ $t('bases.texto_documentacion_2') }}</p>
                                        <p>{{ $t('bases.texto_documentacion_3') }}</p>

                                        <b><p>- {{ $t('bases.dni_jugador') }}</p></b>
                                        <b><p>- {{ $t('bases.dni_responsables') }}</p></b>
                                    </b-col>
                                </b-row>
                            </b-modal>
                        </div>
                    </div>
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <div class="mt-4 mb-2">
                            <b-card v-if="error === 'no'" bg-variant="success" title="Éxito" class="mb-4">
                                <b-card-text>
                                    {{ $t('bases.exito') }}
                                </b-card-text>
                            </b-card>
                            <b-card v-if="error === 'si'" bg-variant="danger" title="Fallo">
                                <b-card-text>
                                    {{ $t('bases.error') }}
                                </b-card-text>
                            </b-card>
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-4">
                                    <FormInput
                                        v-model="localData.nombre"
                                        id="nombre"
                                        rules="required"
                                        :disabled="loading"
                                        :label="$t('formularios.nombre')"
                                        :name="$t('formularios.nombre')"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <FormInput
                                        v-model="localData.apellidos"
                                        id="apellidos"
                                        rules="required"
                                        :disabled="loading"
                                        :label="$t('formularios.apellidos')"
                                        :name="$t('formularios.apellidos')"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <DocumentoTipo
                                        id="tipo-documento-comprador"
                                        :value="localData.tipoDocumento"
                                        :index="0"
                                        :disabled="loading"
                                        @input="val => { $set(localData, 'tipoDocumento', val); localData.dni = ''; }"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <DocumentoValor
                                        :type="localData.tipoDocumento"
                                        :value="localData.dni"
                                        :index="0"
                                        :disabled="loading"
                                        inputId="dni"
                                        @input="val => { localData.dni = val; }"
                                    />
                                </div>
                                <DateInput
                                    v-model="localData.fecha_nacimiento"
                                    :label="$t('formularios.nacimiento')"
                                    name="fecha_nacimiento"
                                    id="fecha_nacimiento"
                                    min="1900-01-01"
                                    max="2999-12-31"
                                    rules="required"
                                    :disabled="loading"
                                    wrapper-class="col-12 col-md-6 col-lg-4"
                                    data-cy="fecha-nacimiento"
                                />
                                <DateInput
                                    v-model="localData.fecha_caducidad_dni"
                                    :label="$t('bases.fecha_caducidad_dni')"
                                    name="fecha_caducidad_dni"
                                    id="fecha_caducidad_dni"
                                    min="1900-01-01"
                                    max="2999-12-31"
                                    rules="required"
                                    :disabled="loading"
                                    dateValidation="noPast"
                                    wrapper-class="col-12 col-md-6 col-lg-4"
                                    data-cy="fecha_caducidad_dni"
                                />
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label>{{ $t('formularios.telefono') }}</label>
                                        <PhoneInput
                                            dataCy="telefono"
                                            :phone="localData.telefono ?? null"
                                            :desactivar="loading"
                                            :forceValidate="forcePhoneValidation"
                                            :required="true"
                                            @setNumber="(number) => localData.telefono = number"
                                            @validNumber="(valid) => isValidNumber = valid"
                                        />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <FormInput
                                        v-model="localData.email"
                                        type="email"
                                        id="email"
                                        rules="required|email"
                                        :disabled="loading"
                                        :label="$t('formularios.email')"
                                        :name="$t('formularios.email')"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <Paises
                                            id="pais_de_nacimiento"
                                            :desactivar="loading"
                                            :errors="errors"
                                            :pais="localData.pais_de_nacimiento ?? pais"
                                            @rellenarPais="rellenarPais"
                                            v-on:selected="
                                                (opt) => {
                                                    pais = opt;
                                                    localData.pais_de_nacimiento = opt;
                                                    localData.pais_nacimiento_id = opt.id;
                                                    if (opt.nombre !== 'España') {
                                                        provincia = null;
                                                        localData.provincia_nacimiento = null;
                                                        localData.provincia_nacimiento_id = null;
                                                        localData.localidad_nacimiento = null;
                                                        localData.localidad_nacimiento_id = null;
                                                        localData.nacionalidad = '';
                                                    }
                                                }
                                            "
                                        />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4" v-if="isSpain">
                                    <div class="form-group">
                                        <Provincias
                                            id="provincia_nacimiento"
                                            :desactivar="loading"
                                            :errors="errors"
                                            :pais="pais?.id"
                                            :provincia="localData.provincia_nacimiento ?? provincia"
                                            v-on:selected="
                                                (opt) => {
                                                    provincia = opt;
                                                    localData.provincia_nacimiento = opt;
                                                    localData.provincia_nacimiento_id = opt.id;
                                                }
                                            "
                                        />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4" v-if="isSpain">
                                    <div class="form-group">
                                        <Locations
                                            id="localidad_nacimiento"
                                            :desactivar="loading"
                                            :provincia="provincia"
                                            :location_id="localData.localidad_nacimiento?.id"
                                            :errors="errors"
                                            :localidad="localData.localidad_nacimiento?.nombre"
                                            v-on:selected="
                                                (opt) => {
                                                    localData.localidad_nacimiento = opt;
                                                    localData.localidad_nacimiento_id = opt.id;
                                                }
                                            "
                                            :forceMultiselect="true"
                                        />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <FormInput
                                        v-model="localData.nacionalidad"
                                        id="nacionalidad"
                                        rules="required"
                                        :disabled="loading"
                                        :label="$t('formularios.nacionalidad')"
                                        :name="$t('formularios.nacionalidad')"
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <FormInput
                                        v-model="localData.direccion"
                                        id="domicilio"
                                        rules="required"
                                        :disabled="loading"
                                        :label="$t('formularios.domicilio')"
                                        :name="$t('formularios.domicilio')"
                                    />
                                </div>
                                <div v-if="categorias_bases" class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label>{{ $t('bases.cuota') }} *</label>
                                        <ValidationProvider name="categoria_base" rules="required" v-slot="{ errors }">
                                            <multiselect
                                                v-model="localData.categoria_base"
                                                :class="errors[0] ? 'is-invalid' : ''"
                                                placeholder="Categoría Base"
                                                data-cy="categoria_base"
                                                label="name"
                                                track-by="id"
                                                :multiple="false"
                                                :options="categorias_bases"
                                                v-on:select="
                                                    (selectedOpt) => $emit('setNewStep', selectedOpt)
                                                "
                                                :disabled="loading"
                                            >
                                                <template slot="option" slot-scope="props">
                                                    <div class="option__desc"><span class="option__title">{{ props.option.name }}</span> - <span class="option__small">{{ props.option.precio | formatear_precio }}</span></div>
                                                </template>
                                            </multiselect>
                                            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div v-if="equipos" class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label>{{ $t('bases.equipo') }} *</label>
                                        <ValidationProvider name="equipo" rules="required" v-slot="{ errors }">
                                            <multiselect
                                                v-model="localData.equipo"
                                                :class="[errors[0] ? 'is-invalid' : '', 'custom-multiselect']"
                                                placeholder="Equipo"
                                                label="nombre"
                                                track-by="id"
                                                data-cy="equipos"
                                                :multiple="false"
                                                :options="equipos"
                                                :disabled="loading"
                                            />
                                            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label>{{ $t('bases.lateralidad') }} *</label>
                                        <ValidationProvider name="lateralidad" id="lateralidad" rules="required" v-slot="{ errors }">
                                            <multiselect
                                                v-model="localData.lateralidad"
                                                :class="(errors[0] ? 'is-invalid' : '')"
                                                placeholder="Lateralidad"
                                                id="lateralidad"
                                                :multiple="false"
                                                :options="lateralidades"
                                                data-cy="lateralidad"
                                                v-on:select="
                                                    (selectedOpt) => $emit('selected', selectedOpt)
                                                "
                                                :disabled="loading"
                                            />
                                            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="club_de_procedencia">{{ $t('bases.club_procedencia') }}</label>
                                        <ValidationProvider name="club_de_procedencia">
                                            <input
                                                v-model="localData.club_de_procedencia"
                                                id="club_de_procedencia"
                                                type="text"
                                                class="form-control rounded-pill"
                                                :placeholder="$t('bases.club_procedencia')"
                                                :disabled="loading"
                                            />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <template v-if="fields && fields.length > 0">
                                    <div v-for="(field, index) in fields" :key="index" :class="'col-12' + (field.type !== 'textarea' ? ' col-lg-4' : '')">
                                        <FieldComponent
                                            :field="field"
                                            :desactivar="loading"
                                            v-model="localData.fields_deportista[field.name]"
                                        />
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="text-right mt-3">
                            <Button
                                v-if="active"
                                id="volver-paso-1"
                                type="button"
                                :label="$t('formularios.atras')"
                                :disabled="loading"
                                custom-class="mr-2"
                                @click="volver"
                            />
                            <Button
                                id="terminar-paso-1"
                                type="submit"
                                data-cy="terminar-paso-1"
                                :label="$t('formularios.continuar')"
                                :disabled="loading"
                            />
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Provincias from "../../common/forms/Provincias.vue";
    import Locations from "../../common/forms/Locations.vue";
    import Paises from "../../common/forms/Paises.vue";
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import FieldComponent from '@/components/common/FieldComponent.vue';
    import DateInput from '@/modules/ui/DateInput.vue';
    import Button from "@/modules/ui/Button.vue";
    import DocumentoTipo from '@/components/common/DocumentoTipo';
    import DocumentoValor from '@/components/common/DocumentoValor';

    export default {
        props: {
            base: {
                type: Object,
                required: true
            },
            codigo_invitacion: {
                type: String,
                default: null
            },
            esMovil: {
                type: Boolean,
                default: false
            },
            fields: {
                type: Array,
                default: () => []
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                errors: [],
                error: this.$route.query.error,
                provincia: null,
                pais: null,
                nacionalidad: "Española",
                selected: null,
                items: null,
                categorias_bases: [],
                lateralidades: ['Diestro', 'Zurdo', 'Ambidiestro'],
                show_modal: false,
                esRenovacion: window.location.href.indexOf("renovar") > -1,
                equipos: null,
                localData: { ...this.base },
                isValidNumber: false,
                forcePhoneValidation: false,
                loading: false
            };
        },
        created() {
            if (!this.localData.tipoDocumento) {
                this.$set(this.localData, 'tipoDocumento', 'DNI');
            }

            if (!this.localData.fields_deportista) {
                this.$set(this.localData, 'fields_deportista', {});
            }

            if (!this.manager.activar_compra_por_invitacion_bases) {
                let parametros = {
                    lista_id: this.lista_id,
                    filters: {
                        tid: this.configuracion.hash_teatro
                    }
                }
                this.$store.dispatch(this.config.getVuexAlias("back.categorias.bases"), parametros).then(res => {
                    this.categorias_bases = res.data.data;
                    if (this.categorias_bases && this.categorias_bases.length == 1) {
                        this.localData.categoria_base = this.categorias_bases[0];
                        this.$emit('setNewStep', this.localData.categoria_base);
                    }
                });
            } else {
                let params = {
                    filters: {
                        codigo_invitacion: this.codigo_invitacion
                    }
                }
                this.$store.dispatch(this.config.getVuexAlias('front.bases.codigo.get-categoria'), params).then(res => {
                    this.categorias_bases = [res.data.categoria];
                });
            }

            this.getEquipos();

            if(this.localData.pais_de_nacimiento) {
                this.pais = Object.assign({}, this.localData.pais_de_nacimiento);
            }

            if(this.localData.provincia_nacimiento === null || this.localData.provincia_nacimiento === undefined) {
                if (this.teatro.provincia) {
                    this.localData.provincia_nacimiento = this.teatro.provincia;
                }
            } else {
                this.provincia = this.localData.provincia_nacimiento;
            }
        },
        methods: {
            terminar() {
                this.loading = true;
                this.localData['teatro_id'] = this.teatro.id;
                this.localData['metodo_pago'] = 5;
                this.localData['taquilla'] = 0;
                this.localData['codigo_invitacion'] = this.codigo_invitacion;
                this.localData['equipo_id'] = this.localData['equipo'] ? this.localData['equipo']['id'] : null;

                this.localData['descuento_integro'] = 0;
                this.localData['descuento_aplicado'] = 0;

                this.localData['categoria_base_id'] = this.localData['categoria_base']['id']

                let params = {
                    base: this.localData,
                    filters: {
                        tid: this.configuracion.hash_teatro,
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-datos-deportista'), params).then(res => {
                    this.localData.session_id = res.data.session_id;
                    this.localData['categoria_base']['session_id'] = res.data.session_id;
                    this.localData.jet_id = res.data.jet_id;
                    this.$emit("terminado", this.localData);
                }).catch(e => {
                    console.error(e)
                }).finally(() => {
                    this.loading = false;
                });
            },
            rellenarPais(pais) {
                this.pais = pais;
                this.localData.pais_nacimiento_id = pais.id;
            },
            async submit() {
                if (!this.localData.telefono) this.forcePhoneValidation = true;

                const isValid = await this.$refs.observer.validate();
                if(isValid && this.isValidNumber && this.localData.telefono) {
                    this.terminar();
                }
            },
            getEquipos() {
                let params = {
                    filters: {
                        teatro_id: this.teatro.id
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias("front.bases.equipos"), params).then(res => {
                    this.equipos = res.data.data;
                });
            },
            volver() {
                this.$emit('volver');
            }
        },
        watch: {
            provincia(newVal, oldVal) {
                if (oldVal && newVal && oldVal.id !== newVal.id) {
                    this.localData.localidad_nacimiento = null;
                    this.localData.localidad_nacimiento_id = null;
                }
            },
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_id() {
                return this.$route.params.lista_id;
            },
            isSpain() {
                return this.pais && this.pais.nombre === 'España';
            },
        },
        components: { Paises, Locations, Provincias, PhoneInput, FieldComponent, DateInput, Button, DocumentoTipo, DocumentoValor  },
    };
</script>
